import http from "@/http/aisea/axios";
const resource = "/enterprises/owners/manning_vessels";
const resourceCrews = "/enterprises/owners/crews";

export default {
  fetchVesselInfo(enterpriseManningVesselId) {
    return http.get(`${resource}/${enterpriseManningVesselId}`);
  },
  vessels(enterpriseCrewId, payload) {
    return http.get(`${resourceCrews}/${enterpriseCrewId}/manning/vessels`, {
      ...payload,
    });
  },
};
